<div *ngIf="firsttable">
    <table 
     
    
      [dataSource]="dataSource"
      
      mat-table
      matSort
      style="width: 100%"
    >
    <!-- <ng-container matColumnDef="action">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
       N°
      </th>
      <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
    </ng-container> -->
    
    
    
    
    
    <ng-container matColumnDef="cateNm">
      <th  *matHeaderCellDef mat-header-cell >
       
        [ {{ "Identifiant de la classification" | translate }} ] {{ "Nom de la classification" | translate }}
      </th>
      <td width="60%" *matCellDef="let d" mat-cell>
        
        <a style="color: #0000FF"  *ngIf="d.finalCate==0" (click)="sendID(d.cateId)">[ {{ d.cateId }} ] {{ d.cateNm }}   </a> 
        <a style="color: #0000FF"    *ngIf="d.finalCate==1" (click)="hamza(d.cateId)">[ {{ d.cateId }} ] {{ d.cateNm }} </a> 
    
        </td>
    </ng-container>
    
    
    
    
    <ng-container matColumnDef="telecharger">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
      
      </th>
      <td width="20%" *matCellDef="let d" mat-cell style="text-align: center;" >
<!--         <button type="button" class="btn btn-primary btn-sm">Telecharger</button>
 -->    
    
    </td>
    </ng-container>
    
    <!-- <ng-container matColumnDef="voir">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
        
        </th>
        <td width="20%" *matCellDef="let d" mat-cell style="text-align: center;" >
            <button type="button" class="btn btn-primary btn-sm">Voir</button>
    
        </td>
      </ng-container> -->
    
    
      
    
      
    
    
    
    
     <!--  <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
    
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          {{ column | translate }}
        </th>
        
        <td *matCellDef="let type" mat-cell>
          {{ type[column] | typedValue | async }}
        </td>
      </ng-container> -->
      <tr  *matHeaderRowDef="readColumns" mat-header-row></tr>
      <tr  *matRowDef="let row; columns: readColumns" mat-row></tr> 
      
       
    
    
      
    </table>
    <app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
    </div>
    
    <div *ngIf="firsttable==false">
      <table
    
      [dataSource]="dataSource2"
      
      mat-table
      matSort
      style="width: 100%"
    >
    <!-- <ng-container matColumnDef="action">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
       N°
      </th>
      <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
    </ng-container> -->
    
    
    
    
    
    <ng-container matColumnDef="categorie">
      <th  *matHeaderCellDef mat-header-cell >
       
        [ {{ "Identifiant de la classification" | translate }} ] {{ "Nom de la classification" | translate }}
      </th>
      <td width="40%" *matCellDef="let d" mat-cell>
        
         [ {{ d.cateId }} ] {{ d.cateNm }}
        </td>
    </ng-container>
    
    
    
    
    <ng-container matColumnDef="prodId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
        {{ "prodId" | translate }}
      </th>
      <td *matCellDef="let d" mat-cell style="text-align: center;" >{{ d.prodId }}</td>
    </ng-container>
    
    
    <ng-container matColumnDef="prodNm">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          {{ "prodNm" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>{{ d.prodNm }}</td>
      </ng-container>
      
    
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell ></th>
        <td *matCellDef="let d" mat-cell>
            <a (click)="opendialogannonce(d)" mat-icon-button>
            <mat-icon style="color: #00a8ff;">info</mat-icon>
          </a>  
          <!-- <a mat-icon-button>
            <mat-icon style="color: #00a8ff;">info</mat-icon>
          </a> -->
    
        </td>
      </ng-container>
    
    
    
    
     <!--  <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
    
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          {{ column | translate }}
        </th>
        
        <td *matCellDef="let type" mat-cell>
          {{ type[column] | typedValue | async }}
        </td>
      </ng-container> -->
      <tr  *matHeaderRowDef="readColumns2" mat-header-row></tr>
      <tr  *matRowDef="let row; columns: readColumns2" mat-row></tr> 
      
       
    
    
      
    </table>
    <app-empty-list-container
    [list]="dataSource2.data"
    [withoutBorder]="true"
    ></app-empty-list-container>
    </div>
